

import cookie from 'js-cookie'
import axios from 'axios'
import qs from 'qs'
//import $ from 'jquery'
import Bus from 'vue'
import Vuex from '../../vuex/store.js'
export default {
    install(Vue, options) {
        Vue.prototype.getCurrentEnv = function() {
            /*
            local          --           本地调试
            ckl            --           内网
            test           --           外测
            production     --           生产
            */
            return 'production'
        }
        window.getCurrentEnv = function(){
            return Vue.prototype.getCurrentEnv();
        }
        
        
        Vue.prototype.getWSDomain = function() {
            let env = this.getCurrentEnv();
            let protocol = location.protocol;
            let origin = '//ws.ckl.com';
            if (env == 'test') {
                origin = '//test-ws.forclass.net';
                /*
                origin = '//test.webservice.forclass.net';
                origin = '//test.ws.eduzibo.com';
                */
            }
            if (env == 'production') {
                origin = '//webservice.forclass.net';
                //origin = '//ws.forclass.net';
            }

            return protocol + origin;
        }

        Vue.prototype.$event = new Bus()


        Vue.prototype.startLoading = function() {
            Vue.prototype.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
            });
        }

        Vue.prototype.stopLoading = function() {
            Vue.prototype.loading.close();
        }

        // 获取session
        Vue.prototype.getSession = function() {
            var acnt = this.loadAccount()
            if (this.isValid(acnt) &&
                this.isValid(acnt.session)) {
                return acnt.session
            }
        }


        Vue.prototype.getLocalVal = function(key) {
            var value = (typeof localStorage[key] == "undefined" || localStorage[key] == "undefined") ? "" : localStorage[key]
            return value
        }

        Vue.prototype.updateLocal = function(key, value) {
            localStorage[key] = value
        }

        Vue.prototype.getSessionVal = function(key) {
            var value = (typeof sessionStorage[key] == "undefined" || sessionStorage[key] == "undefined") ? "" : sessionStorage[key]
            return value
        }

        // Vue.prototype.loadAccount = function() {
        //     let device = this.getSessionVal('device') || window.navigator.userAgent.toLowerCase().indexOf('wke') >= 0
        //     let tool = this.getSessionVal('tool')
        //     let clientBrowser = device || tool
        //     let account = null
        //         //客户端（教师端，学生端）浏览器允许使用sessionStorage；PC浏览器只允许使用Cookie
        //     if (this.isSupportJSON()) {
        //         let cookieAccount = this.getCookie('account')
        //         let sessionAccount = this.getSessionVal('account')
        //         if (clientBrowser && this.isValid(sessionAccount) && sessionAccount != '') {
        //             account = JSON.parse(sessionAccount)
        //         } else if (this.isValid(cookieAccount) && cookieAccount != '') {
        //             account = this.getCookie('account')
        //         }
        //     }
        //     return account
        // }
        Vue.prototype.loadAccount = function() {
            // let device = this.getSessionVal('device') || window.navigator.userAgent.toLowerCase().indexOf('wke') >= 0
            // let tool = this.getSessionVal('tool')
            // let clientBrowser = device || tool
            // let account = null
            //     //客户端（教师端，学生端）浏览器允许使用sessionStorage；PC浏览器只允许使用Cookie
            // if (this.isSupportJSON()) {
            //     let cookieAccount = this.getCookie('account')
            //     let sessionAccount = this.getSessionVal('account')
            //     if (clientBrowser && this.isValid(sessionAccount) && sessionAccount != '') {
            //         account = JSON.parse(sessionAccount)
            //     }
            //     if (this.isValid(cookieAccount) && cookieAccount != '') {
            //         account = this.getCookie('account')
            //     }
            // }
            // return account



            let device = this.getSessionVal('device') || window.navigator.userAgent.toLowerCase().indexOf('wke') >= 0
            let tool = this.getSessionVal('tool')
            let clientBrowser = device || tool
            let account = null
                //客户端（教师端，学生端）浏览器允许使用sessionStorage；PC浏览器只允许使用Cookie
            if (this.isSupportJSON()) {
                let cookieAccount = this.getCookie('account')
                let sessionAccount = this.getSessionVal('account')
                if (clientBrowser && this.isValid(sessionAccount) && sessionAccount != '') {
                    account = JSON.parse(sessionAccount)
                } else {
                    if (cookieAccount) {
                        account = cookieAccount
                    } else {
                        account = (sessionAccount && sessionAccount != "") ? JSON.parse(sessionAccount) : null
                    }
                }
            }
            return account

        }
        Vue.prototype.loadPlatform = function() {
            let device = this.getSessionVal('device') || window.navigator.userAgent.toLowerCase().indexOf('wke') >= 0
            let tool = this.getSessionVal('tool')
            let clientBrowser = device || tool
            let platform = null
            if (this.isSupportJSON()) {
                let cookiePlatform = this.getCookie('platform')
                let sessionPlatform = this.getSessionVal('platform')
                if (clientBrowser && this.isValid(sessionPlatform) && sessionPlatform != '') {
                    platform = JSON.parse(sessionPlatform)
                } else if (this.isValid(cookiePlatform) && cookiePlatform != '') {
                    platform = this.getCookie('platform')
                }
            }
            return platform
        }

        Vue.prototype.updateSession = function(key, value) {
            sessionStorage[key] = value
        }

        Vue.prototype.getCookie = function(name) {
            return cookie.getJSON(name)
        }

        Vue.prototype.setCookie = function(name, value, options) {
            if (this.isValid(name)) {
                cookie.set(name, value, options)
            }
        }

        Vue.prototype.getUrlC = function(m) {
            return this.getWSDomain() + this.getWebServiceURL3(m)
        }

        Vue.prototype.getWebServiceURL3 = function(m) {
            return "/ConsoleService.asmx/" + m
        }
        
        Vue.prototype.getWebServiceURL = function(m) {
            return "/ANAService.asmx/" + m
        }
        
        Vue.prototype.getWebServiceURL7 = function(m) {
          return "/AccountService.asmx/" + m
        }
        //var g_upgrademsgshowed = false
        Vue.prototype.getANAFTSServiceURL = function(m) {
            return "/ANAFileTransferService.asmx/" + m
        }

       // 深拷贝
        Vue.prototype.deepCopyForJson = function(collection) {
            return JSON.parse(JSON.stringify(collection))
        }


        Vue.prototype.isSupportJSON = function() {
            var support = JSON != null && typeof JSON != 'undefined'
            if (!support && !g_upgrademsgshowed) {
                g_upgrademsgshowed = true
                alert("您的浏览器版本过低，请升级浏览器。")
            }

            return support
        }

        Vue.prototype.isValid = function(value) {
            return value != null && typeof value != 'undefined'
        }


        Vue.prototype.getDomain = function() {
            var domain = window.location.hostname.split('.')
            var arrLength = domain.length
            if (arrLength >= 2) {
                domain = domain[arrLength - 2] + '.' + domain[arrLength - 1]
            }

            return domain
        }

        Vue.prototype.appendScriptToBody = function(id, $scriptObj) {
            $scriptObj.attr('id', id)
            if ($("#" + id).length == 0) {
                let $body = $('body')
                let $lastScriptEle = $body.find('script:last')
                if ($lastScriptEle.length > 0) {
                    $scriptObj.insertAfter($lastScriptEle)
                } else {
                    $body.append($scriptObj)
                }
            }
        }

        Vue.prototype.appendStyleSheetToBody = function(id, $styleSheet) {
            $styleSheet.attr('id', id)
            if ($("#" + id).length == 0) {
                let $head = $('head')
                let $lastStyleSheetEle = $head.find('style:last')
                if ($lastStyleSheetEle.length > 0) {
                    $styleSheet.insertAfter($lastStyleSheetEle)
                } else {
                    $head.append($styleSheet)
                }
            }
        }

        Vue.prototype.isValid = function(value) {
            return value != null && typeof value != 'undefined'
        }

        Vue.prototype.isValidInt = function(prop, minValue) {
            if (!this.isValid(prop) || !$.isNumeric(prop) || prop <= minValue)
                return false

            return true
        }

        Vue.prototype.isValidArray = function(arr) {
            if (!this.isValid(arr) || !this.isValid(arr.length) || arr.length < 1)
                return false
            return true
        }
        Vue.prototype.saveAccount = function(acnt) {
          if (!this.isValidArray(acnt.dlserver))
              acnt.dlserver = "/"

          if (this.isSupportJSON()) {
              sessionStorage.account = JSON.stringify(acnt)
          }
          this.$account = acnt
          this.$store.commit({ type: 'UPDATE_ACCOUNT', account: { Account: acnt } })
        }
        Vue.prototype.loadSession = function(result, that) {
            if (that.isValidArray(result)) {
                var account = result[0]
                let clientSession = that.getSession()
                
                let serverSession = account.session
                let loginUrl = "/Account/SignIn"
                if (that.isValid(serverSession) && (clientSession == serverSession)) {
                    var realname = account.realname
                    var showname = account.showname
                    var username = (realname == null || realname == "") ? showname : realname
                    var classidx = (account.classidx > 0 ? account.classidx : 0)
                    var classname = ((account.classname == null || account.classname == undefined) ? "" : account.classname)
                    var acnt = {
                        "userid": account.userid,
                        "session": account.session,
                        "loginname": account.showname,
                        "realname": account.realname,
                        "account": username,
                        "role": account.role,
                        "period": account.period,
                        "coin": account.coin,
                        "level": account.level,
                        "email": account.email,
                        "avatar": account.avatar,
                        "dlserver": account.dlserver,
                        "zoneidx": account.zoneidx,
                        "schoolidx": account.schoolidx,
                        "role1": account.role,
                        "classidx": classidx,
                        "classname": classname,
                        "zonename": account.zone,
                        "schoolname": account.school,
                        'zonelevel': account.zonelevel,
                        'platformzonelevel': account.platformzonelevel,
                        'zonelevelname': account.zonelevelname,
                        'showname': account.showname,
                        'sourceid': account.sourceid
                    }
                    that.saveAccount(acnt)
                } else {
                    console.log('client session not equal with server session')
                        //location.href = loginUrl
                }
            } else {
                console.log('请检查服务器返回的session')
                sessionStorage.removeItem('account')
                    //that.setCookie('account', null, { expires: -1, path: that.getDomain() })
                cookie.set('account', null, { expires: -1, path: that.getDomain() })
                that.$store.commit({ type: 'UPDATE_ACCOUNT', account: { Account: null } })
                    //location.href = loginUrl
            }
        }
        Vue.prototype.postAxios = function(api, param, handler) {
            this.startLoading()
            axios({
                url: api,
                method: 'post',
                data: qs.stringify(param),
                baseURL: this.getWSDomain(),
                timeout: 0,
                withCredentials: false,
                xsrfCookieName: 'XSRF-TOKEN',
                xsrfHeaderName: 'X-XSRF-TOKEN'
            }).then(res=>{
                this.stopLoading();
                handler(res)
            }).catch((e)=>{
                this.stopLoading();
                console.log(e)
            })
        },
        Vue.prototype.validateSession = function(callback) {
            let outSiteName = Vuex.state.fromOtherSite.name
            if(outSiteName == 'shuangshuang')return
            let that = this
            let loginUrl = '/Account/SignIn'
            let clientSession = this.getSession()
            if (!this.isValid(clientSession)) {
                console.log('未获取到本地session')
                    // location.href = loginUrl
            } else {
                let param = { 'session': clientSession, 'page': 0, 'hostName': window.location.hostname }
                    // axios.post(this.getWSDomain() + "/ANAService.asmx/LoginSessionJson", qs.stringify(param)).then((response) => {})
                    /*
                                                        axios.all([axios.post(this.getWSDomain() + "/ANAService.asmx/LoginSessionJson", qs.stringify(param))]).then(axios.spread(function(result) {

                                                        }))
                                                        return
                                                        */
                let api = this.getWSDomain() + this.getWebServiceURL7('LoginSessionJson')

                axios({
                    url: api,
                    method: 'post',
                    baseURL: this.getWSDomain(),
                    data: qs.stringify(param),
                    timeout: 0,
                    withCredentials: false,
                    xsrfCookieName: 'XSRF-TOKEN',
                    xsrfHeaderName: 'X-XSRF-TOKEN'
                }).then((response) => {
                    var d = this.getResultData(response.data)
                    that.loadSession(d, that)
                    
                })
            }
        }
        Vue.prototype.getResultData = function(data) {
            if (typeof data.result !== 'undefined' && data.result != null) {
                return data.result
            }

            return data
        }

        var g_ajaxQueue = []
        var g_ajaxIsRunning = false
        Vue.prototype.addToQueue = function(methodName, inputObj, handleFunc, target, runNow) {
            g_ajaxQueue.push(this.sendRequest(methodName, inputObj, handleFunc, target))
            if (runNow) {
                /*
                axios.all(g_ajaxQueue).then(axios.spread((response) => {
                    console.log(response)
                }))
                */
            }
        }

        // Vue.prototype.sendRequest = function(methodName, inputObj, handleFunc, target, next) {
        //     if (this.isValid(inputObj)) {
        //         var dataObj = {}

        //         var session = this.getSession()
        //         if (session != null)
        //             Object.assign(dataObj, { "session": session })
        //         else
        //             Object.assign(dataObj, { "session": "" })
        //         if (!this.isValidInt(inputObj.page, -1))
        //             inputObj.page = 0

        //         Object.assign(dataObj, inputObj)

        //         var contentType = "application/x-www-form-urlencoded"
        //         var dataType = "json"
        //         g_ajaxIsRunning = true
        //         if (!this.isValid(window.ajaxRandomArr)) {
        //             window.ajaxRandomArr = []
        //         }
        //         window.ajaxRandomArr.push(Math.random())
        //         axios({
        //             url: methodName,
        //             method: "post",
        //             baseURL: this.getWSDomain(),
        //             /*
        //             transformRequest: [function(data) {

        //                 return data
        //             }],
        //             transformResponse: [function(data) {

        //             }],
        //             */
        //             /*//谨慎使用
        //             headers: { 'Access-Control-Allow-Origin': '*' },
        //             params: qs.stringify(dataObj),
        //             paramsSerializer: function(params) {
        //                 return qs.stringify(params, { arrarFormat: 'brackets' })
        //             },
        //             */
        //             data: this.$qs.stringify(dataObj),
        //             timeout: 0,
        //             withCredentials: false,
        //             /*//谨慎使用
        //             adapter: function(config) {

        //             },
        //             */
        //             auth: null, //谨慎使用
        //             //responseType: dataType,   //谨慎使用
        //             xsrfCookieName: 'XSRF-TOKEN',
        //             xsrfHeaderName: 'X-XSRF-TOKEN',
        //             //maxContentLength: 2000,
        //             /*
        //             validateStatus: function(status) { //研究一下
        //                 return status >= 200 && status < 300
        //             },
        //             maxRedirects: 5,
        //             httpAgent: new http.Agent({ keepAlive: true }),
        //             httpsAgent: new https.Agent({ keepAlive: true }),
        //             proxy: {
        //                 host: 'ws.ckl.com',
        //                 port: '80',
        //                 auth: {}
        //             },
        //             cancelToken: new axios.CancelToken(function(cancel) {

        //             })
        //             */
        //         }).then((response) => {
        //             g_ajaxIsRunning = false
        //             window.ajaxRandomArr.pop()
        //             var d = response.data
        //             if (this.isValid(d)) {
        //                 var rc = this.getReturnCode(d)
        //                 if (rc == 1) {
        //                     var np = this.getResultNextPage(d)
        //                     if (np > 0) {
        //                         inputObj.page = np
        //                         this.addToQueue(methodName, inputObj, handleFunc, target, true)
        //                     }

        //                     var result = this.getResultData(d)
        //                     handleFunc(result, target, np)
        //                         // need get more pages
        //                 } else if (rc < 1) {
        //                     // hide waiting msg
        //                     // return error
        //                     var result = this.getResultData(d)
        //                     handleFunc(result, target, 0)
        //                 }
        //             } else {
        //                 handleFunc(-1, target, 0)
        //             }
        //         }).catch(function(error) {
        //             console.log(error)
        //             g_ajaxIsRunning = false
        //         })
        //     }
        // }


        // 封装的简单发送请求
        Vue.prototype.sendRequest = function(methodName, inputObj, handleFunc, isLoading) {
            if(isLoading){
                this.startLoading();
            }
            this.$axios.post(methodName,inputObj)
            .then(res=>{
                if(isLoading){
                    Vue.prototype.stopLoading()
                }
                res = res.data
                handleFunc(res)
            })
        }
        // 课程平台请求地址
        Vue.prototype.courseUrl = function(){
            let env = this.getCurrentEnv()
            if(env=='test'){
              return location.protocol+'//test.api.forclass.net/CourseAll/api'
            }else if(env=='production'){
              return location.protocol+'//api.forclass.net/CourseAll/api'
            }
          }
        // 学习设计请求地址
        Vue.prototype.designUrl = function(){
            // return 'http://10.135.192.6:808/api/v1'
            let env = this.getCurrentEnv()
            let platform = this.$store.state.platform;
            let PlatformSystemNumber = 0;
            if(this.isValid(platform)){
                PlatformSystemNumber = platform.PlatformSystemNumber;
            }else if(this.$route.query.platfromNumber){
                PlatformSystemNumber = this.$route.query.platfromNumber;
            }
            // console.log(this.$route.query.platfromNumber)
            // console.log(PlatformSystemNumber)
            if(env=='test'){
                if(PlatformSystemNumber == '000024' || PlatformSystemNumber == '000030' || PlatformSystemNumber == '000019' || PlatformSystemNumber == '000001' ||  PlatformSystemNumber == 0){
                    return location.protocol+'//test.api.forclass.net/CourseLH/api/v1'
                }else{
                    return location.protocol+'//test.api.forclass.net/Course/api/v1'
                }
            }else if(env=='production'){
                if(PlatformSystemNumber == '000024' || PlatformSystemNumber == '000030'  || PlatformSystemNumber == '000019' || PlatformSystemNumber == '000001' || PlatformSystemNumber == 0){
                    return location.protocol+'//api.forclass.net/CourseLH/api/v1'
                }else{
                    return location.protocol+'//api.forclass.net/Course/api/v1'
                }
            }
        }


        Vue.prototype.getDeviceInfo = function(){
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || (this.getParentUrl() && this.getParentUrl().includes('MobilePreview'))) {
                return 'mobile'
            } else {
                return 'pc'
            }
        } 
        Vue.prototype.getParentUrl = function(){ 
            var url = null;
            if (parent !== window) { 
                try {
                   url = parent.location.href; 
                }catch (e) { 
                   url = document.referrer; 
                } 
            }
            return url;
        }

        Vue.prototype.getMobileInfo = function(){
            var u = navigator.userAgent;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            if(isiOS){
                return 'ios'
            }else if(isAndroid){
                return 'android'
            }
        }

        Vue.prototype.webApiUrl = function(){
            let env = this.getCurrentEnv()
            if(env=='test'){
              return location.protocol+'//test.api.forclass.net'
            }else if(env=='production'){
              return location.protocol+'//api.forclass.net'
            }
        } 

        Vue.prototype.noteUrl = function(){
            let env = this.getCurrentEnv()
            if(env=='test'){
              return location.protocol+'//test.api.forclass.net/notes/api/Notes'
            }else if(env=='production'){
              return location.protocol+'//api.forclass.net/notes/api/Notes'
            }
        } 
        
        Vue.prototype.getWebServiceURL8 = function(m) {
            return "/PaasService.asmx/" + m
        }


        Vue.prototype.getRequestParamValue = function(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
            var ret = regex.exec(location.search)
            return ret == null ? "" : decodeURIComponent(ret[1].replace(/\+/g, " "))
        }

        Vue.prototype.getNavList = function(callback) {
            let hostName = window.location.hostname
            let account = this.loadAccount()
            let param = {
                session: this.getSession() || this.getRequestParamValue("session") || null,
                hostName: hostName,
                platformNumber: '',
                platformName: null,
                role: account ? account.role : null
            }

            // this.Platform = this.getDefaultPlatformInfo()
            // this.$store.commit({ type: 'UPDATE_PLATFORM', platform: this.Platform })
            // return
            // console.log(param)
            let api = this.getWSDomain() + this.getWebServiceURL8('GetPlatformSystemHost')
            // console.log(api)

            axios({
                method:'post',
                timeout: 0,
                withCredentials: false,
                auth: null,
                xsrfCookieName: 'XSRF-TOKEN',
                xsrfHeaderName: 'X-XSRF-TOKEN',
                headers:{
                },
                url:api,
            data:qs.stringify(param),
            }).then(res=>{
                let platform = null
                if (this.isValidArray(res.data.result)) {
                    platform = res.data.result[0]
                } else {
                    platform = this.getDefaultPlatformInfo()
                }
                // console.log(platform)
                window.document.title = platform.PlatformSystemName
                this.$store.commit({ type: 'UPDATE_PLATFORM', platform: platform })
                if (typeof(callback) == 'function') {
                    callback(platform)
                }
            })
        }

        Vue.prototype.getNavigationUrl = function(alias) {
            let data = this.getHostInfo(alias)
            console.log('data='+data)
            if (this.isValid(data)) {
                let protocol = location.protocol
                if (protocol == 'https:') {
                    return protocol + "//" + data.HostName + data.Path
                } else {
                    return data.Url
                }
            }
            return ''
        }
        Vue.prototype.getHostInfo = function(alias) {
            let platform = this.$store.state.platform
            if (this.isValid(platform)) {
                let hostList = platform.NavList
                let linkList = platform.InNavList
                if (this.isValid(hostList) && this.isValid(linkList)) {
                    hostList = hostList.concat(linkList)
                }
                if (this.isValidArray(hostList)) {
                    for (var i = 0; i < hostList.length; i++) {
                        var host = hostList[i]
                        let childList = host.ModList
                        if (host.Alias == alias) {
                            console.log(host)
                            return host
                            break
                        }
                        if (this.isValidArray(childList)) {
                            for (let j = 0; j < childList.length; j++) {
                                let childHost = childList[j]
                                if (childHost.Alias == alias) {
                                    console.log(childHost)
                                    return childHost
                                    break
                                }
                            }
                        }
                    }
                }
            }

            return null
        }

        // 获取签名
        Vue.prototype.getSignatureUrl = function(){
          // return 'http://10.135.192.6:808/api/v1'
          return `${this.getWSDomain()}/File/GetOssPolicy2Signature?userid=${Vue.prototype.loadAccount().userid}&bucket=forcass-res`
        }
        Vue.prototype.getWebServiceURL13 = function(m) {
          return "/GooseService.asmx/" + m
        }
        // 获取平台
        Vue.prototype.getDefaultPlatformInfo = function() {
            return {
                PlatformSystemNumber: '000001',
                PlatformSystemName: 'ForClass教育资源公共服务平台',
                CurrentSystemAlias: 'home',
                ZoneIdx: 1,
                NavList: [{
                        Name: '首页',
                        Alias: 'home',
                        HostName: 'paas.forclass.net',
                        Enabled: true
                    },
                    {
                        Name: '资源',
                        Alias: 'res',
                        HostName: 'res.forclass.net',
                        Enabled: true
                    },
                    {
                        Name: '视频',
                        Alias: 'v',
                        HostName: 'v.forclass.net',
                        Enabled: true
                    },
                    {
                        Name: '社区',
                        Alias: 'cm',
                        HostName: 'cm.forclass.net',
                        Enabled: true
                    },
                    {
                        Name: '作业',
                        Alias: 'zzn',
                        HostName: 'zzn.forclass.net',
                        Enabled: true
                    },
                    {
                        Name: '空间',
                        Alias: 'zone',
                        HostName: 'zone.forclass.net',
                        Enabled: true
                    },
                    {
                        Name: '统计',
                        Alias: 'cm',
                        HostName: 'st.forclass.net',
                        Enabled: true
                    },
                    {
                        Name: '管理',
                        Alias: 'console',
                        HostName: 'console.forclass.net',
                        Enabled: true
                    }
                ]
            }
        }


        Vue.prototype.getDownloadXml = function(list, type, className) {
            let $xml = $('<download>', {
                'type': type,
                'classname': className
            });
            if (this.isValidArray(list)) {
                for (var i = 0; i < list.length; i++) {
                    var item = list[i];
                    var url = item.url;
                    var name = item.name;
                    var source = item.source || '资源导出';
                    var size = item.size || '未知';
                    var dataid = item.dataid;
                    var $item = $('<item>', {
                        'url': url,
                        'showname': name,
                        'source': source,
                        'Size': size,
                        'dataid': dataid
                    });
                    $item.appendTo($xml);
                }
            }
            return $xml;
        }

        Vue.prototype.setAccountResourceQuery = function(callback) {
            let param = {
                session: this.getSession(),
                sysType: 2
            }
            let unitList = this.getLocalVal("unitList")
            unitList = this.isValid(unitList) && unitList != '' ? JSON.parse(unitList) : []
            let accountQuery = {
                PeriodName: this.getLocalVal("speriod"),
                SubjectName: this.getLocalVal("ssubject"),
                EditionName: this.getLocalVal("sedition"),
                TermName: this.getLocalVal("sterm"),
                BookName: this.getLocalVal("sbook"),
                UnitList: unitList,
                RSName: this.getLocalVal("sscope"),
                RTName: this.getLocalVal("stype"),
                ATName: this.getLocalVal("sattachtype"),
                CTName: this.getLocalVal("screatetype")
            }
            accountQuery = JSON.stringify(accountQuery)
            param.arqName = accountQuery
            let api = this.getWSDomain() + this.getWebServiceURL4('SetAccountResourceQuery')
            this.$http.post(api, this.$qs.stringify(param)).then((res) => {
                if (typeof(callback) == 'function') {
                    callback()
                }
            })
        }

        Vue.prototype.getWebServiceURL4 = function(m) {
          return "/ResourceService.asmx/" + m
        }
        Vue.prototype.isImg = function(url) {
            if (this.isValid(url)) {
                let index = url.indexOf('?')
                if (index > 0) {
                    url = url.substring(0, index)
                }
                let ext = url.substring(url.lastIndexOf('.')).toLowerCase()
                let arr = [".jpg", ".jpeg", ".png", ".bmp", ".gif", ".svg"]
                if (arr.indexOf(ext) >= 0) {
                    return true
                }
            }
            return false
        }

        Vue.prototype.getDownloadServer = function() {
            let acnt = this.loadAccount();
            return this.isValid(acnt) && this.isValidArray(acnt.dlserver) ? acnt.dlserver : "/";
        }

        Vue.prototype.getAttachFileUrl = function(url) {
            let ret = ""
            if (this.isValid(url)) {
                let items = url.split('|')
                let params = "";
                if (this.isValidArray(items) && items.length >= 3) {
                    ret = this.getDownloadServer() + "AttachFiles/" + items[2] + "/" + encodeURI(items[1])
                } else {
                    ret = url
                }
            }
            return $.trim(ret)
        }

        Vue.prototype.getUrlCourse = function(m) {
            return this.getWSDomain() + this.getWebServiceURL13(m)
        }

        Vue.prototype.replaceUrl2OSSCDN = function(url) {
            if (url) {
                url = url.replace("forcass-res.oss-cn-qingdao.aliyuncs.com", "fcdata.forclass.net");
                url = url.replace("//AttachFiles", "/AttachFiles");
                url = url.replace("//CKLAttachFiles", "/CKLAttachFiles");
            }

            return url;
        }
        
        Vue.prototype.sendCPPMessage = function(data, type, className, callback, multiple, maxNum, maxSize) {
            let device = this.getSessionVal('device')
            if (type == 'scrollScreen') {
                var scrollY = data.scrollY;
                var $item = $('<scrolly>', {
                    'num': scrollY
                });
                var result = $item.prop('outerHTML');
                CallCPP(result);
            } else if (type == 'export' || type == 'open') {
                var $result = this.getDownloadXml(data, type, className);
                var result = $result.prop('outerHTML');
                CallCPP(result);
            } else if (type == 'touchmode') {
                var $item = $('<touchmode>', {
                    'enable': data
                })
                var result = $item.prop('outerHTML');
                CallCPP(result);
            } else if (type == 'upload' || type == 'uploadimage' || type == 'uploadppt' || type == 'uploaddcf' || type == 'uploadres') {
                if (device == 'androidPadCKL') {
                    let that = this
                    let baseOrigin = location.protocol + '//'
                    if (this.getCurrentEnv() == "production") {
                        baseOrigin += 'zzn.271bay.com'
                    } else {
                        baseOrigin += 'test.zzn.271bay.com'
                    }
                    let notifyStr = baseOrigin + '/Account/UpdateAndroidFileState'
                    let isMulti = this.isValid(multiple) ? multiple : false
                    let maxUploadNum = this.isValidInt(maxNum, 0) ? maxNum : 1
                    let maxUploadSize = this.isValid(maxSize) ? maxSize : 0
                    let singleUploadFlag = false // 保证每次只取一次有效结果，防止多次渲染
                    if (isMulti) {
                        notifyStr = baseOrigin + '/Account/UpdateFileState'
                    }
                    var currid = setInterval(function() {
                        $.post(baseOrigin + "/Account/Polling", { session: that.getSession() },
                            function(data) {
                                if (that.isValid(data) && data != '' && !singleUploadFlag) {
                                    singleUploadFlag = true
                                    if (data.indexOf("SUCCESS") == 0) { // 单文件上传
                                        clearInterval(currid);
                                        var rets = data.split('|');
                                        if (that.isValidArray(rets) && rets.length > 1) {
                                            let obj = {
                                                'uniqueName': rets[1],
                                                'url': that.replaceUrl2OSSCDN(rets[2]),
                                                'name': rets[3],
                                                'size': rets[4]
                                            }
                                            callback(obj)
                                        }
                                        $.post(baseOrigin + "/Account/ClearAndroidCache", { session: that.getSession() }, function() {});
                                    } else { // 多文件上传
                                        clearInterval(currid);
                                        let arr = eval(data)
                                        if (that.isValidArray(arr)) {
                                            let trans_arr = []
                                            for (let i = 0; i < arr.length; i++) {
                                                trans_arr.push({
                                                    'uniqueName': arr[i].UniqueName,
                                                    'url': that.replaceUrl2OSSCDN(arr[i].Url),
                                                    'name': arr[i].Name,
                                                    'size': arr[i].FileSize
                                                })
                                            }
                                            callback(trans_arr)
                                        }
                                        $.post(baseOrigin + "/Account/ClearAndroidCache", { session: that.getSession() }, function() {});
                                    }
                                }
                            });
                    }, 3000);
                    let mimeType = '*/*'
                    if (type == 'uploadimage') {
                        mimeType = 'image/*'
                    }
                    if (type == 'uploadppt') {
                        mimeType = 'ppt,pptx'
                    }
                    if (type == 'uploaddcf') {
                        mimeType = 'dcf'
                    }
                    if (type == 'uploadres') {
                        mimeType = 'image/*,ppt,pptx,dcf,doc,docx,xls,xlsx,wps,pdf,txt,mp3,mp4,mov,mpeg'
                    }

                    var androidParam = {
                        'cmd': 'fileUpload',
                        'multiple': isMulti,
                        'maxNum': maxUploadNum,
                        'mimeType': mimeType,
                        'notifyUrl': notifyStr,
                        'maxsize': maxUploadSize
                    };
                    console.log(androidParam)
                    HostApp.alert(androidParam);
                } else {
                    // pc客户端上传
                    let that = this
                    let baseOrigin = location.protocol + '//'
                    if (this.getCurrentEnv() == "production") {
                        baseOrigin += 'zzn.271bay.com'
                    } else {
                        baseOrigin += 'test.zzn.271bay.com'
                    }
                    let notifyStr = baseOrigin + '/Account/UpdateFileState'
                    let isMulti = this.isValid(multiple) ? multiple : false
                    let maxUploadNum = this.isValidInt(maxNum, 0) ? maxNum : 1
                    let maxUploadSize = this.isValid(maxSize) ? maxSize : 0
                    let singleUploadFlag = false // 保证每次只取一次有效结果，防止多次渲染
                    var currid = setInterval(function() {
                        $.post(baseOrigin + "/Account/Polling", { session: that.getSession() },
                            function(data) {
                                console.log(data)
                                if (that.isValid(data) && data != '' && !singleUploadFlag) {
                                    singleUploadFlag = true
                                    var list = $.parseJSON(data);
                                    if (that.isValidArray(list)) {
                                        clearInterval(currid);
                                        var arr = [];
                                        for (var i = 0; i < list.length; i++) {
                                            var item = list[i];
                                            var name = item.Name;
                                            var uniqueName = item.UniqueName;
                                            var size = item.FileSize;
                                            var url = item.Url;
                                            var res = {
                                                'uniqueName': uniqueName,
                                                'url': that.replaceUrl2OSSCDN(url),
                                                'name': name,
                                                'size': size
                                            };
                                            arr.push(res);
                                        }
                                        callback(arr);
                                        $.post(baseOrigin + "/Account/ClearAndroidCache", { session: that.getSession() }, function() {});
                                    }
                                }
                            });
                    }, 3000);
                    let mimeType = ''
                    let acceptStr = null
                    if (type == 'uploadimage') {
                        mimeType = 'img'
                        acceptStr = '.jpg,.jpeg,.png'
                    }
                    if (type == 'uploadppt') {
                        mimeType = '*.ppt'
                        acceptStr = '.ppt,.pptx'
                    }
                    if (type == 'uploaddcf') {
                        mimeType = '*.dcf'
                        acceptStr = '.dcf'
                    }
                    if (type == 'uploadres') {
                        mimeType = '*'
                        acceptStr = '.ppt,.pptx,.dcf,.mp3,.mp4,.mov,.mpeg,.doc,.docx,.xls,.xlsx,.wps,.pdf,.txt,.jpg,.jpeg,.gif,.png,.bmp'
                    }
                    var cppParam = {
                        'cmd': 'fileUpload',
                        'mimeType': mimeType,
                        'multiple': isMulti,
                        'accept': acceptStr,
                        'maxNum': maxUploadNum,
                        'notifyUrl': notifyStr,
                        'jsCallback': 'coursepccallback',
                        'maxsize': maxUploadSize
                    };
                    var $item = $('<upload>', cppParam)
                    var result = $item.prop('outerHTML');
                    console.log(result)
                    CallCPP(result);
                }
            } else {
                //客户端下载
                var result = null;
                if (data.constructor == Array) {
                    var $result = this.getDownloadXml(data, type, className);
                    result = $result.prop('outerHTML');
                } else if (data.constructor == Object) {
                    var $dir = $('<batchdownload>', { 'dirname': data.name });
                    var childList = data.childlist;
                    if (this.isValidArray(childList)) {
                        for (var i = 0; i < childList.length; i++) {
                            var $xml = this.getDownloadXml([childList[i]], type, data.name);
                            $xml.appendTo($dir);
                        }
                    }
                    result = $dir.prop('outerHTML');
                }
                CallCPP(result);
            }
        }

        Vue.prototype.getDownloadXml = function(list, type, className) {
            let $xml = $('<download>', {
                'type': type,
                'classname': className
            });
            if (this.isValidArray(list)) {
                for (var i = 0; i < list.length; i++) {
                    var item = list[i];
                    var url = item.url;
                    var name = item.name;
                    var source = item.source || '资源导出';
                    var size = item.size || '未知';
                    var dataid = item.dataid;
                    var $item = $('<item>', {
                        'url': url,
                        'showname': name,
                        'source': source,
                        'Size': size,
                        'dataid': dataid
                    });
                    $item.appendTo($xml);
                }
            }
            return $xml;
        }
        /**
         * 
         * android客户端下载资源
         * 
         */
        Vue.prototype.downResByAndroid = function(arr) {
            // this.$notify({
            //     title: '下载成功',
            //     message: arr[0].subject + arr[0].unitName,
            //     type: 'success',
            //     duration:5000
            // });
            let downloadList = []
            let device = this.getSessionVal("device")
            if(device == "androidPadCKL"){
                arr.forEach(item=>{
                    let url = this.getAttachFileUrl(item.url)
                    downloadList.push({
                        url: url,
                        subject: item.subject || '其他',
                        fleName: item.name,
                        encryption: item.encryption || 0,
                        catalog: item.unitName || '其他'
                    })
                })
                let param = {
                    cmd: 'webPageResDownload',
                    list: downloadList
                }
                HostApp.alert(param)
            }
        }
        // 单独给课程平台使用 有的参数 请求时不需要
        Vue.prototype.delParams = function(notDelCourseId) {
            if(this.isValid(this.$route.query['from'])){
                delete this.$route.query['from'] // 切换第一层级tab时。需要将from去掉。from参数用于 课程详情页使用的
            }
            
            if(this.isValid(this.$route.query['Ctype'])){
                delete this.$route.query['Ctype'] // 切换第一层级tab时。需要将from去掉。from参数用于 课程详情页使用的
            }
            if(!notDelCourseId){
                if(this.isValid(this.$route.query['courseId'])){
                    delete this.$route.query['courseId']
                }
            }
        }
        //防抖
        Vue.prototype.debounce = function (fn,delay) {
            let timer = null;
            return (...args) =>{
                clearTimeout(timer);
                timer = setTimeout(()=>{
                    fn(...args)
                },delay);
            }
        },


        Vue.prototype.formatDate = (date)=> {
            var date = new Date(date);
            var YY = date.getFullYear() + '-';
            var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
            var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            return YY + MM + DD +" "+hh + mm + ss;
        },


        //平板端的拍照 拍视频
        // type 可能值为 recordImage、recordVideo
                    // callback 为回调函数
        Vue.prototype.userRecordingImage_Video = function(type, callback) {
            var device = this.getSessionVal('device')
            if (device == 'androidPadCKL') {
                let that = this
                let baseOrigin = location.protocol + '//'
                if (this.getCurrentEnv() == "production") {
                    baseOrigin += 'zzn.271bay.com'
                } else {
                    baseOrigin += 'test.zzn.271bay.com'
                }
                let notifyStr = baseOrigin + '/Account/UpdateAndroidFileState'
                let singleUploadFlag = false
                var currid = setInterval(function() {
                    $.post(baseOrigin + "/Account/Polling", { session: that.getSession() }, function(data) {
                        if (that.isValid(data) && data != '' && !singleUploadFlag) {
                            if (data.indexOf("SUCCESS") == 0) { // 单文件上传
                                clearInterval(currid);
                                var rets = data.split('|');
                                if (that.isValidArray(rets) && rets.length > 1) {
                                    let obj = {
                                        'uniqueName': rets[1],
                                        'url': that.replaceUrl2OSSCDN(rets[2]),
                                        'name': rets[3],
                                        'size': rets[4]
                                    }
                                    callback(obj)
                                }
                                $.post(baseOrigin + "/Account/ClearAndroidCache", { session: that.getSession() }, function() {});
                            } 
                        }
                    });
                }, 3000);
                let mimeType = '*/*'
                if (type == 'recordImage') {
                    mimeType = 'image/*'
                }
                if (type == 'recordVideo') {
                    mimeType = 'video/*'
                }
                var androidParam = {
                    'cmd': 'fileUpload',
                    'mimeType': mimeType,
                    'notifyUrl': notifyStr,
                };
                console.log(androidParam)
                HostApp.alert(androidParam);
            }
        }
        Vue.prototype.checkHideInOtherSite = function(e){
            let position = e
            let role = Vuex.state.fromOtherSite.role
            let outSiteName = Vuex.state.fromOtherSite.name
            if(outSiteName != 'shuangshuang')return
            Vue.nextTick(() => {
                $('[hide-in-shuangshuang='+e+']').each(function(){
                    //导航栏
                    if(position == 'header-main'){
                        $(this).hide()
                    }
                    //课程详情页
                    if(position == 'jia-ru-xue-xi' && role != 'student'){
                        $(this).hide()
                    }
                    //统计页整个左侧
                    if(position == 'tong-ji-left' && role == 'teacher'){
                        $(this).hide()
                        $('.sjtj-content').css('width','100%')
                    }
                    //统计左侧个人数据部分
                    if(position == 'tong-ji-ge-ren' && (role == 'zoneAdmin' || role == 'schoolAdmin' || role == 'resourceReview')){
                        if($(this).text().trim()=='个人数据'){
                            $(this).parent().hide()
                        }
                    }
                    
                    let resourceCreateList = [
                        'course-create-stu-preview',
                        'chuang-jian-zhuang-tai',
                        'child-tabs',
                        'course-detail-stu-preview'
                    ]
                    if(resourceCreateList.includes(position) && role == 'resourceCreate'){
                        $(this).hide()
                    }
                    if(position == 'course-create-subjective'  && role == 'resourceCreate'){
                        if($(this).text() == '主观题'){
                            $(this).closest('.template-item-box').hide()
                        }
                    }
                    //我的课程-课程创建-状态
                    if(position == 'chuang-jian-zhuang-tai' && role == 'resourceCreate'){
                        if($(this).text().trim().includes('校')){
                          $('.child-tabs').hide()
                          $('.customePadding').css('padding','0px')
                        }
                    }
                    if(position == 'child-tabs'){
                        $('.customePadding').css('padding','0px')
                        $('.child-tabs').hide()
                    }
                    //我的课程-课程审核-状态
                    if(position == 'shen-he-zhuang-tai' && role == 'resourceReview'){
                        if($(this).text().trim().includes('区域')){
                            let text = $(this).text().trim()
                            let newText = text.replace(/区域/g,' ')
                            $(this).text(newText)
                        }
                    }
                })
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js